/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectTaskCommand } from '../../models/delete-project-task-command';
import { DeleteProjectTaskCommandResult } from '../../models/delete-project-task-command-result';

export interface ApiProjectTaskDeleteProjectTaskDelete$Plain$Params {
      body?: DeleteProjectTaskCommand
}

export function apiProjectTaskDeleteProjectTaskDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectTaskDeleteProjectTaskDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskDeleteProjectTaskDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectTaskCommandResult>;
    })
  );
}

apiProjectTaskDeleteProjectTaskDelete$Plain.PATH = '/api/ProjectTask/DeleteProjectTask';
